import React from 'react';
import '../plugins/plugin-config';
export const CoreContext = React.createContext({
    serverUrl: '',
    getPluginAxios: null,
});
